import { LOCALES } from 'config/constants/locales';
import { getLocalePathPrefix } from './locale-path-prefix';
import { stripLocalePathPrefix } from './strip-locale-path-prefix';

export const withLocalePathPrefix = (
  path: string,
  locale?: string,
  defaultLocale: string = LOCALES.DE
): string => {
  const cleanPath = stripLocalePathPrefix(path.startsWith('/') ? path : `/${path}`);

  return `${getLocalePathPrefix(locale, defaultLocale)}${cleanPath}`;
};
